const powerupsCanvas = document.getElementById('powerups');
const trailCanvas = document.getElementById('game');
const headsCanvas = document.getElementById('heads');
const arenaFrameEl = document.getElementById('arenaFrame');
const arenaEl = document.getElementById('arena') || document.getElementById('game-layout');
const netStatusEl = document.getElementById('net-status');
const scoreListEl = document.getElementById('scores');
const targetDisplayEl = document.getElementById('targetDisplay');
const stopMatchBtnEl = document.getElementById('stopMatchBtn');
const muteBtnEl = document.getElementById('muteBtn');
const muteBtnLabelEl = document.getElementById('muteBtnLabel');
const muteBtnIconEl = document.getElementById('muteBtnIcon');
const pauseBtnEl = document.getElementById('pauseBtn');
const pauseBtnLabelEl = document.getElementById('pauseBtnLabel');
const pauseBtnIconEl = document.getElementById('pauseBtnIcon');
const settingsBtnEl = document.getElementById('settingsBtn');
const leaveBtnEl = document.getElementById('leaveBtn');
const lobbyPeekBtnEl = document.getElementById('lobbyPeekBtn');
const devReloadBtnEl = document.getElementById('devReloadBtn');
const chatFeedEl = document.getElementById('chatFeed');
const botPlaybackControlsEl = document.getElementById('botPlaybackControls');
const botRecordBtnEl = document.getElementById('botRecordBtn');
const botPlayBackBtnEl = document.getElementById('botPlayBackBtn');
const botPlayPauseBtnEl = document.getElementById('botPlayPauseBtn');
const botPlayForwardBtnEl = document.getElementById('botPlayForwardBtn');
const botPlayLastBtnEl = document.getElementById('botPlayLastBtn');
const botPlayClearBtnEl = document.getElementById('botPlayClearBtn');
const botPlaybackStatusEl = document.getElementById('botPlaybackStatus');
const botPlaybackTitleEl = document.getElementById('botPlaybackTitle');
const chatFormEl = document.getElementById('chatForm');
const chatGuestLockEl = document.getElementById('chatGuestLock');
const chatFormFieldsEl = document.getElementById('chatFormFields');
const chatEmoteBtnEl = document.getElementById('chatEmoteBtn');
const chatEmotePopEl = document.getElementById('chatEmotePop');
const sideChatPanelEl = document.getElementById('sideChatPanel');
const lobbyChatEl = document.getElementById('lobby-chat');
const lobbyChatTitleEl = document.getElementById('lobby-chat-title');
const lobbyChatBodyEl = document.getElementById('lobby-chat-body');
const chatChannelButtons = Array.from(document.querySelectorAll('.chat-channel-btn'));
const chatChannelTitleEls = [lobbyChatTitleEl].filter(Boolean);
// One presence badge per chat header. Only one header is on screen at a time
// (the lobby card's, or the in-game side panel's), and both show the same
// count, so they are updated together rather than picked between.
const chatPresenceEls = [
  document.getElementById('lobby-chat-presence'),
  document.getElementById('side-chat-presence')
].filter(Boolean);
const chatInputEl = document.getElementById('chatInput');
const chatSendBtnEl = document.getElementById('chatSendBtn');
const settingsModalEl = document.getElementById('settings-modal');
const settingsCloseBtnEl = document.getElementById('settingsCloseBtn');
const settingsSoundVolumeEl = document.getElementById('settingsSoundVolume');
const settingsSoundVolumeValueEl = document.getElementById('settingsSoundVolumeValue');
const settingsTurnRadiusEl = document.getElementById('settingsTurnRadius');
const settingsTurnRadiusValueEl = document.getElementById('settingsTurnRadiusValue');
const settingsControlLeftBtnEl = document.getElementById('settingsControlLeftBtn');
const settingsControlRightBtnEl = document.getElementById('settingsControlRightBtn');
const settingsResolutionEl = document.getElementById('settingsResolution');
const settingsResolutionValueEl = document.getElementById('settingsResolutionValue');
const settingsInputLagEl = document.getElementById('settingsInputLag');
const settingsInputLagValueEl = document.getElementById('settingsInputLagValue');
const settingsKeyTimestampToggleEl = document.getElementById('settingsKeyTimestampToggle');
const settingsPowerupSpawnToggleEl = document.getElementById('settingsPowerupSpawnToggle');
const roundOverlayEl = document.getElementById('roundOverlay');
const focusOverlayEl = document.getElementById('focusOverlay');
const overlayKickerEl = document.getElementById('roundOverlayKicker');
const overlayWinnerNameEl = document.getElementById('roundOverlayWinnerName');
const overlayWinnerTailEl = document.getElementById('roundOverlayWinnerTail');
const overlayLabelEl = document.getElementById('roundOverlayLabel');
const overlayCountdownEl = document.getElementById('roundOverlayCountdown');
const matchResultsEl = document.getElementById('matchResults');
const authOverlayEl = document.getElementById('auth-overlay');
const authNameInputEl = document.getElementById('auth-name');
const authSigninBtnEl = document.getElementById('auth-signin-btn');
const authRegisterBtnEl = document.getElementById('auth-register-btn');
const authCloseBtnEl = document.getElementById('authCloseBtn');
const authStatusEl = document.getElementById('auth-status');
const lobbyOverlayEl = document.getElementById('lobby-overlay');
const lobbyTitleEl = document.getElementById('lobby-title');
const lobbyRoomPillEl = document.getElementById('lobby-room-pill');
// The pill holds an icon alongside its text, so the label is its own node:
// writing textContent on the pill itself would delete the icon.
const lobbyRoomPillLabelEl = document.getElementById('lobby-room-pill-label');
const lobbyIdentityPillEl = document.getElementById('lobby-identity-pill');
const lobbyIdentityNameEl = document.getElementById('lobby-identity-name');
const lobbyIdentityTagEl = document.getElementById('lobby-identity-tag');
const lobbyIdentityAvatarEl = document.getElementById('lobby-identity-avatar');
const lobbyNavLobbyBtnEl = document.getElementById('lobby-nav-lobby-btn');
const lobbyNavBotlabBtnEl = document.getElementById('lobby-nav-botlab-btn');
const lobbyNavSettingsBtnEl = document.getElementById('lobby-nav-settings-btn');
const lobbySubtitleEl = document.getElementById('lobby-subtitle');
const lobbyCountLabelEl = document.getElementById('lobby-count-label');
const lobbyCountEl = document.getElementById('lobby-count');
const lobbyStartRuleLabelEl = document.getElementById('lobby-start-rule-label');
const lobbyStartRuleEl = document.getElementById('lobby-start-rule');
const lobbyReadyEl = document.getElementById('lobby-ready');
const lobbyProgressFillEl = document.getElementById('lobby-progress-fill');
const lobbyHintEl = document.getElementById('lobby-hint');
const lobbyCopyBtnEl = document.getElementById('lobby-copy-btn');
const lobbyReturnGroupEl = document.getElementById('lobby-return-group');
const lobbyRejoinMatchBtnEl = document.getElementById('lobby-rejoin-match-btn');
const lobbyRejoinRoomBtnEl = document.getElementById('lobby-rejoin-room-btn');
const lobbyBackBtnEl = document.getElementById('lobby-back-btn');
const lobbyLogoutBtnEl = document.getElementById('lobby-logout-btn');
const lobbyRoomActionsEl = document.getElementById('lobby-room-actions');
const lobbyRoomNameInputEl = document.getElementById('lobby-room-name-input');
const lobbyRoomPasswordInputEl = document.getElementById('lobby-room-password-input');
const lobbyCreateFormatSelectEl = document.getElementById('lobby-create-format-select');
const lobbyHostFormatSelectEl = document.getElementById('lobby-host-format-select');
const lobbyCreateMinSelectEl = document.getElementById('lobby-create-min-select');
const lobbyCreateMaxSelectEl = document.getElementById('lobby-create-max-select');
const lobbyCreateModeSelectEl = document.getElementById('lobby-create-mode-select');
const lobbyNewRoomBtnEl = document.getElementById('lobby-new-room-btn');
const lobbyRoomListEl = document.getElementById('lobby-room-list');
const lobbyRoomFiltersEl = document.getElementById('lobby-room-filters');
const lobbyRoomSearchInputEl = document.getElementById('lobby-room-search-input');
const lobbyActionRowEl = document.getElementById('lobby-action-row');
const lobbyHostSettingsGroupEl = document.getElementById('lobby-host-settings-group');
const lobbyHostBotsGroupEl = document.getElementById('lobby-host-bots-group');
const lobbyHostNameInputEl = document.getElementById('lobby-host-name-input');
const lobbyHostMinSelectEl = document.getElementById('lobby-host-min-select');
const lobbyHostMaxSelectEl = document.getElementById('lobby-host-max-select');
const lobbyHostModeToggleEl = document.getElementById('lobby-host-mode-toggle');
const lobbyHostAddBotBtnEl = document.getElementById('lobby-host-add-bot-btn');
const lobbyHostRemoveBotBtnEl = document.getElementById('lobby-host-remove-bot-btn');
const lobbyHostBotCountEl = document.getElementById('lobby-host-bot-count');
const lobbyHostStartBtnEl = document.getElementById('lobby-host-start-btn');
const lobbyHostStartGroupEl = document.getElementById('lobby-host-start-group');
const lobbyPlayerListEl = document.getElementById('lobby-player-list');
const lobbySpectatorsEl = document.getElementById('lobby-spectators');
const lobbySpectatorCountEl = document.getElementById('lobby-spectator-count');
const lobbySpectatorPagerEl = document.getElementById('lobby-spectators-pager');
const lobbySpectatorPrevBtnEl = document.getElementById('lobby-spec-prev-btn');
const lobbySpectatorNextBtnEl = document.getElementById('lobby-spec-next-btn');
const lobbySpectatorPageLabelEl = document.getElementById('lobby-spec-page-label');
const lobbySpectateToggleBtnEl = document.getElementById('lobby-spectate-toggle-btn');
const lobbyResumeMatchBtnEl = document.getElementById('lobby-resume-match-btn');
const lobbySpectatorListEl = document.getElementById('lobby-spectator-list');
const lobbySettingsBtnEl = document.getElementById('lobbySettingsBtn');

export {
  powerupsCanvas,
  trailCanvas,
  headsCanvas,
  arenaFrameEl,
  arenaEl,
  netStatusEl,
  scoreListEl,
  targetDisplayEl,
  stopMatchBtnEl,
  muteBtnEl,
  muteBtnLabelEl,
  muteBtnIconEl,
  pauseBtnEl,
  pauseBtnLabelEl,
  pauseBtnIconEl,
  settingsBtnEl,
  leaveBtnEl,
  lobbyPeekBtnEl,
  devReloadBtnEl,
  chatFeedEl,
  botPlaybackControlsEl,
  botRecordBtnEl,
  botPlayBackBtnEl,
  botPlayPauseBtnEl,
  botPlayForwardBtnEl,
  botPlayLastBtnEl,
  botPlayClearBtnEl,
  botPlaybackStatusEl,
  botPlaybackTitleEl,
  chatFormEl,
  chatGuestLockEl,
  chatFormFieldsEl,
  chatInputEl,
  chatSendBtnEl,
  settingsModalEl,
  settingsCloseBtnEl,
  settingsSoundVolumeEl,
  settingsSoundVolumeValueEl,
  settingsTurnRadiusEl,
  settingsTurnRadiusValueEl,
  settingsControlLeftBtnEl,
  settingsControlRightBtnEl,
  settingsResolutionEl,
  settingsResolutionValueEl,
  settingsInputLagEl,
  settingsInputLagValueEl,
  settingsKeyTimestampToggleEl,
  settingsPowerupSpawnToggleEl,
  roundOverlayEl,
  focusOverlayEl,
  overlayKickerEl,
  overlayWinnerNameEl,
  overlayWinnerTailEl,
  overlayLabelEl,
  overlayCountdownEl,
  matchResultsEl,
  authOverlayEl,
  authNameInputEl,
  authSigninBtnEl,
  authRegisterBtnEl,
  authCloseBtnEl,
  authStatusEl,
  lobbyOverlayEl,
  lobbyTitleEl,
  lobbyRoomPillEl,
  lobbyRoomPillLabelEl,
  lobbyIdentityPillEl,
  lobbyIdentityNameEl,
  lobbyIdentityTagEl,
  lobbyIdentityAvatarEl,
  lobbyNavLobbyBtnEl,
  lobbyNavBotlabBtnEl,
  lobbyNavSettingsBtnEl,
  lobbySubtitleEl,
  lobbyCountLabelEl,
  lobbyCountEl,
  lobbyStartRuleLabelEl,
  lobbyStartRuleEl,
  lobbyReadyEl,
  lobbyProgressFillEl,
  lobbyHintEl,
  lobbyCopyBtnEl,
  lobbyReturnGroupEl,
  lobbyRejoinMatchBtnEl,
  lobbyRejoinRoomBtnEl,
  lobbyBackBtnEl,
  lobbyLogoutBtnEl,
  lobbyRoomActionsEl,
  lobbyRoomNameInputEl,
  lobbyRoomPasswordInputEl,
  lobbyCreateFormatSelectEl,
  lobbyHostFormatSelectEl,
  lobbyCreateMinSelectEl,
  lobbyCreateMaxSelectEl,
  lobbyCreateModeSelectEl,
  lobbyNewRoomBtnEl,
  lobbyRoomListEl,
  lobbyRoomFiltersEl,
  lobbyRoomSearchInputEl,
  lobbyActionRowEl,
  lobbyHostSettingsGroupEl,
  lobbyHostBotsGroupEl,
  lobbyHostNameInputEl,
  lobbyHostMinSelectEl,
  lobbyHostMaxSelectEl,
  lobbyHostModeToggleEl,
  lobbyHostAddBotBtnEl,
  lobbyHostRemoveBotBtnEl,
  lobbyHostBotCountEl,
  lobbyHostStartBtnEl,
  lobbyHostStartGroupEl,
  lobbyPlayerListEl,
  lobbySpectatorsEl,
  lobbySpectatorCountEl,
  lobbySpectatorPagerEl,
  lobbySpectatorPrevBtnEl,
  lobbySpectatorNextBtnEl,
  lobbySpectatorPageLabelEl,
  lobbySpectateToggleBtnEl,
  lobbyResumeMatchBtnEl,
  lobbySpectatorListEl,
  lobbySettingsBtnEl,
  chatEmoteBtnEl,
  chatEmotePopEl,
  sideChatPanelEl,
  lobbyChatEl,
  lobbyChatTitleEl,
  lobbyChatBodyEl,
  chatPresenceEls,
  chatChannelButtons,
  chatChannelTitleEls
};
